import React from 'react';

function Roll(props) {
  return <span className="value roll">{props.roll.name}</span>;
}

export default Roll;
